/**
 * @overview 阿里云相关请求集合
 * */

import { ajaxOldGet } from './oldHttp';
import tools from '../tools/tools.js';

/**
 * 获取阿里云图片上传sign
 */
export default {
  getOssImgUploadSign() {
    console.log('---------ajaxOldGet', ajaxOldGet)
    return ajaxOldGet('app-api/tool/v1/get/oss/upload/sign').then(result => {
      const res = result.rdata;
      return {
        OSSAccessKeyId: res.accessid,
        policy: res.policy,
        Signature: res.signature,
        dir: res.dir,
        key: `${res.dir}${tools.getUUID()}`,
        host: res.host
      };
    });
  }
};



// WEBPACK FOOTER //
// ./src/plugin/upload/oss.js